'use strict';

angular
  .module('completeAir', [
    'ui.router',
    'ngSanitize',
    'ngCookies',
    'ngResource',
    'ngStorage',
    'ui.bootstrap',
    'ui.bootstrap.datetimepicker',
    'ui.select',
    'dialogs.main',
    'ngAnimate',
    'toastr',
    'jcs-autoValidate',
    'tmh.dynamicLocale',
    'pascalprecht.translate',
    'ngFileUpload',
    'LocalStorageModule',
    'ngJsTree',
    'aacMetisMenu',
    'ui.mask',
    'angularMoment',
    'chart.js',
    'ngFileSaver',
    'seatMap',
    'expandCollapseMenu',
    'longSmallMenu',
    'distanceSegment',
    'completeAir.directiveCommon',
    'completeAir.module.directive',
    'completeAir.version',
    'completeAir.datetimePicker',
    'acc-schedule'
  ])
  .constant('CONFIG', {
    //API_URL_LOCAL: 'https://tsagair.transclicksolutions.com',
    //API_URL_SERVER: 'https://tsagair.transclicksolutions.com',
    API_URL_LOCAL: 'https://agair.transclicksolutions.com',
    API_URL_SERVER: 'https://agair.transclicksolutions.com',
    API_URL: '',
    API_CONFIG_GENERAL: 'configg',
    API_FLIGHT_CONTROL: 'flightc',
    API_FARE_CONTROL: 'farec',
    API_FINANCE: 'finance',
    API_CARGO_CONTROL: 'cargo',
    API_KJAR_SERVICE: 'kjar',
    API_PNR: 'pnr',
    API_INVOICE: 'invoice',
    //API_OAUTH: 'https://tsoaair.transclicksolutions.com/uaa',
    API_OAUTH: 'https://oaair.transclicksolutions.com/uaa',
    API_REPORT: 'report',
    API: 'api',
    PUBLIC: 'public',
    SERVER: 'local',
    AUTHORITIES_ADMIN: ['ROLE_ADMIN'],
    AUTHORITIES_ALL: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_COUNTER'],
    USER_ROLES: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_COUNTER'],
    TIME_REFRESH: 30000,
    CLIENT_ID: "client",
    SECRET: "tcs_4dm1n_ui",
    DOMAIN_ID: "air",
    GRANT_TYPE: 'password',
    CLIENT_ID_AIR: 'bus_click',
    SECRET_AIR: 'bus_cl1ck',
    GRANT_TYPE_AIR: 'client_credentials',
    DOMAIN_ID_APP: 'mobile_tam_ep' /*mobile_trans_copacabana*/
  })
  .run(run);

run.$inject = ['$rootScope', '$state', '$stateParams', 'bootstrap3ElementModifier', 'defaultErrorMessageResolver', 'stateHandler'];

function run($rootScope, $state, $stateParams, bootstrap3ElementModifier, defaultErrorMessageResolver, stateHandler) {
  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;

  bootstrap3ElementModifier.enableValidationStateIcons(false);

  defaultErrorMessageResolver.setI18nFileRootPath('i18n/validator');
  defaultErrorMessageResolver.setCulture('es-CO');
  $rootScope.overlayLoading = true;
  $rootScope.dateCurrent = new Date();

  stateHandler.initialize();
}
